import { Variants } from '../types/variant';

// Common for both sommeil variants
const pages = {
  CONSULTATION: {
    title: 'Consultation',
    sections: ['CONTEXTE', 'SOM_MENSURATION'],
  },
  COMPLAINTS: {
    title: 'Motifs',
    sections: ['SOMMEIL-MOTIF', 'SOMMEIL-MOTIF-PREVCON'],
  },
  SOMMEIL_SYMPTOMES: {
    title: 'Symptômes',
    sections: ['SOMMEIL-SYMPTOMES'],
  },
  SOMMEIL_SYMPTOMES_FOLLOWUP: {
    title: 'Précisions sur les symptômes',
    sections: [
      'SOMMEIL-SYMPTOMES_PRECISION',
      'SOMMEIL-SYMPTOMES_PRECISION_REVEIL',
      'SOMMEIL-SYMPTOMES_PRECISION_APNEE',
      'SOMMEIL-SYMPTOMES_PRECISION_RESPINASALE',
    ],
  },
  SOMMEIL_SCORE_01: { title: 'EPWORTH', sections: ['SOMMEIL-EPWORTH'] },
  SOMMEIL_HABITUDES: {
    title: 'Habitudes de sommeil',
    sections: ['SOMMEIL-HABITS'],
  },
  SOMMEIL_HYGIENE_DE_VIE: {
    title: 'Hygiène de vie',
    sections: ['SOMMEIL-HDV'],
  },
  SOMMEIL_SCORE_02: { title: 'PICHOT', sections: ['SOMMEIL-PICHOT'] },
  SOMMEIL_ATCD_01: {
    title: 'Antécédents personnels',
    sections: ['SOMMEIL-ATCD_PERSO'],
  },
  SOMMEIL_ATCD_02: {
    title: 'Antécédents familiaux',
    sections: ['SOMMEIL-ATCD_FAM'],
  },
};

export const sommeilVariants = {
  sommeil: {
    name: 'Sommeil',
    status: 'stable',
    availableInDemo: false,
    description:
      "Questionnaire pour les patients consultant pour des troubles du sommeil. Couvre les motifs, les symptômes, les scores d'Epworth et de Pichot, les habitudes de sommeil, l'hygiène de vie ainsi que les antécédents personnels et familiaux.",
    speciality: 'SOMMEIL',
    patientOnboarding: 'SOMMEIL',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'SLEEP',
    initialQuestions: [],
    initialAssertions: [],
    pages,
    options: [],
    visitMotive: 'Sommeil',
  },
  sommeil_bligny: {
    name: 'Sommeil Bligny',
    status: 'restricted',
    description:
      "Questionnaire pour les patients du Centre Hospitalier de Bligny consultant pour des troubles du sommeil. Couvre les motifs, les symptômes, les scores d'Epworth et de Pichot, les habitudes de sommeil, l'hygiène de vie ainsi que les antécédents personnels et familiaux.",
    speciality: 'SOMMEIL',
    patientOnboarding: 'SOMMEIL_BLIGNY',
    patientOffboarding: 'DIRECT_CONFIRMATION',
    emailTemplate: 'sommeil-bligny',
    reportTemplate: 'SLEEP',
    initialQuestions: [],
    initialAssertions: ['[Médecin: #z‹]-(lieu_exercice)->[CHBligny]'],
    pages,
    options: [],
    visitMotive: 'Sommeil',
  },
  sommeil_generaliste: {
    name: 'Sommeil Généraliste',
    status: 'deprecated',
    description:
      "Questionnaire généraliste pour les patients consultant pour des troubles du sommeil. Couvre les motifs, l'agenda du sommeil, le phénotypage (SAHS, insomnie, somnolence, narcolepsie, SJSR, parasomnie), les scores (Epworth, STOP-BANG, PHQ-2/9), les facteurs associés, la pédiatrie et la synthèse.",
    speciality: 'SOMMEIL-GENERALISTE',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'BASIC_SPECIALTY',
    initialQuestions: [],
    initialAssertions: [],
    pages: {
      CONSULTATION: {
        title: 'Consultation',
        sections: ['CONTEXTE'],
      },
      COMPLAINTS: {
        title: 'Motifs',
        sections: ['MOTIF'],
      },
      AGENDA: {
        title: 'Agenda du sommeil',
        sections: ['AGENDA'],
      },
      PHENOTYPAGE_SAHS: {
        title: 'Apnées du sommeil',
        sections: ['SAHS'],
      },
      PHENOTYPAGE_INSOMNIE: {
        title: 'Insomnie',
        sections: ['INSOMNIE'],
      },
      PHENOTYPAGE_SOMNOLENCE: {
        title: 'Somnolence diurne',
        sections: ['SOM_DIURNE'],
      },
      PHENOTYPAGE_NARCOLEPSIE: {
        title: 'Narcolepsie',
        sections: ['NARCOLEPSIE'],
      },
      PHENOTYPAGE_SJSR: {
        title: 'Syndrome des jambes sans repos',
        sections: ['SJSR'],
      },
      PHENOTYPAGE_PARASOMNIE: {
        title: 'Parasomnie',
        sections: ['PARASOMNIE'],
      },
      SCORES: {
        title: 'Epworth',
        sections: ['EPWORTH'],
      },
      FACTEURS: {
        title: 'Facteurs associés',
        sections: ['FACTEURS_ASSOCIES'],
      },
      HUMEUR: {
        title: 'Humeur',
        sections: ['HUMEUR'],
      },
      PEDIA: {
        title: 'Pédiatrie',
        sections: ['PEDIA'],
      },
    },
    options: [],
    visitMotive: 'Sommeil',
  },
} satisfies Variants;
